import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useUtils as useAclUtils } from "@core/libs/acl";

const { t } = useI18nUtils();
const { canViewVerticalNavMenuHeader } = useAclUtils();

const { headerItems } = "";
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  //  t(this.item.header)
  // render(h) {
  //   console.log(this.item);
  //   console.log(this.$store.state.app.roles);
  //   // if (this.item.role) {
  //   //   if ( this.$store.state.app.roles==this.item.role) {
  //   const span = h("span", {}, t(this.item.header));
  //   const icon = h("feather-icon", {
  //     props: { icon: "MoreHorizontalIcon", size: "18" },
  //   });
  //   return h("li", { class: "navigation-header text-truncate" }, [span, icon]);
  //   //   }
  //   // }
  //   // if (canViewVerticalNavMenuHeader(this.item)) {
  //   //   if(this.$store.state.auth.roles[0] == 'admin'){
  //   //     return h('li', { class: 'navigation-header text-truncate' }, [span, icon])
  //   //   }
  //   //   else if (this.$store.state.auth.roles[0] == this.item.header){
  //   //     return h('li', { class: 'navigation-header text-truncate' }, [span, icon])
  //   //   }
  //   // }
  // },
  render(h) {
    const { header, role } = this.item;
    const userRoles = this.$store.state.app.roles;
    const isSuperAdmin =
      userRoles.includes("super-admin") || userRoles == "super-admin";

    // Helper function to check if user has the required role(s)
    const hasRequiredRole = (requiredRole) => {
      if (!requiredRole) return true;

      // If role is an array, check if user has ANY of the roles (OR logic)
      if (Array.isArray(requiredRole)) {
        return requiredRole.some((r) => userRoles.includes(r));
      }

      // If role is a string, check if user has that role
      return userRoles.includes(requiredRole);
    };

    // Check if role matches or if user is a 'super-admin'
    if ((role && hasRequiredRole(role)) || isSuperAdmin) {
      const span = h("span", {}, t(header));
      const icon = h("feather-icon", {
        props: { icon: "MoreHorizontalIcon", size: "18" },
      });

      return h("li", { class: "navigation-header text-truncate" }, [
        span,
        icon,
      ]);
    }

    // Optionally, you can return null or a placeholder if no condition is met
    return null;
  },
};
